module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bmJQdS/tc-custom/9781423614555.jpg?1736884273818",
      "alt": "This image is the cover for the book Art of Wood-Fired Cooking"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Art of Wood-Fired Cooking\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This guide to using an outdoor oven “skillfully guides the reader” with photos, directions, and recipes for everything from pizza to poultry (Alice Waters).")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Andrea Mugnaini has spent over twenty years perfecting the craft of wood-fired cooking. A pioneer of the industry, she founded the first cooking school dedicated to wood-fired cooking—and her oven importing company has brought the Italian style of cooking and living to America."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("The Art of Wood-Fired Cooking")]), _vm._v(" begins with detailed instructional information on the ins and outs of the wood-burning oven. Mugnaini reveals the methods she has been teaching through her classes—and shares delicious recipes for pizzas, breads, fish, poultry, meats, vegetables, pastas, and desserts. Fire up the oven and enjoy: Butterflied ShrimpZucchini Gratin with Tomatoes and GruyereTuscan-Style Pot Roast with Herbs and ChiantiFocaccia with Onions and ThymeLimoncello Bread Pudding with Fresh Blackberries \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Andrea Mugnaini\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Andrea Mugnaini is the founder of Mugnaini Imports and the Mugnaini Wood-Fired Cooking School. When she is not teaching, Andrea entertains crowds in the Sonoma Wine Country with her live, interactive cooking events.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0